// import axios from "axios";
import axios from "../../axiosConfig";
import { call, put } from "redux-saga/effects";
import { EXPORT_BIDS_FAILED, EXPORT_BIDS_SUCCESS, GET_BIDS_FAILED, GET_BIDS_SUCCESS } from "../Actions/CBidActions";
import { TOAST_SHOW } from "../Actions/ToastAction";

import FileDownload from 'js-file-download';

export function* GetCBidSaga(action: any): unknown {

    try {
        const { hour, userId, ipAddress,appBundle,ipv6 , url } = action.payload
        const response = yield call(axios.get, `getCBids?hour=${hour}&userId=${userId}&appBundle=${appBundle}&ipAddress=${ipAddress}&ipv6=${ipv6}&url=${url}`);
        yield put({ type: GET_BIDS_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: GET_BIDS_FAILED });
        yield put({
            type: TOAST_SHOW,
            payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
        });
    }
}

// export function* exportCBIDDataSaga(action: any): unknown {
//     try {
//         const { hour, userId, ipAddress,appBundle,ipv6, url } = action.payload
//         const response = yield call(axios.get, `/getCBidsDataCSV?hour=${hour}&userId=${userId}&appBundle=${appBundle}&ipAddress=${ipAddress}&ipv6=${ipv6}&url=${url}`);

//         const { data, status } = response

//         if (status === 200) {
//             yield put({ type: EXPORT_BIDS_SUCCESS });
//             FileDownload(data, `cbid_data.csv`);
//         }

//     } catch (e: any) {
//         yield put({ type: EXPORT_BIDS_FAILED });
//         yield put({
//             type: TOAST_SHOW,
//             payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
//         });
//     }
// }